import axios from './index'

export default {
  getOrdersByRef(ref, params) {
    return axios.get(`/api/v1/booking/order/${ref}`, { params })
  },
  getOneOrder(_id, params) {
    return axios.get(`/api/v1/order/${_id}`, { params })
  },
}